import '@aws-amplify/ui-react/styles.css';
import { AuthUser } from 'aws-amplify/auth';
import React, { useState, useEffect } from 'react';
import { Amplify } from 'aws-amplify';
import { getCurrentUser, signInWithRedirect, signOut } from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';
import { Button, View, Card } from '@aws-amplify/ui-react';
import { uploadData } from 'aws-amplify/storage';

import awsconfig from './aws-exports';

// Configure Amplify with updated redirects
//awsconfig.oauth.redirectSignIn = `${window.location.origin}/`;
//awsconfig.oauth.redirectSignOut = `${window.location.origin}/`;
Amplify.configure(awsconfig);

function App() {
  // Amazon Federate Midway athentication
  const [user, setUser] = useState<AuthUser | null>(null);
  // getUser function
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  // Check current user
  async function fetchUser() {
    try {
      const currentUser = await getCurrentUser();
      setUser(currentUser);
    } catch {
      setUser(null);
    }
  }

  useEffect(() => {
    fetchUser();

    const unsubscribe = Hub.listen('auth', ({ payload }) => {
      const { event } = payload;
      console.log('Auth event:', event, payload);

      if (event === 'signInWithRedirect') {
        fetchUser();
      } else if (event === 'signedOut') {
        setUser(null);
      }
    });

    return unsubscribe;
  }, []);

  // Handle image upload
  const handleImageUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    // ... rest of your handleImageUpload code ...
  };

  return (
    <View className="App">
      <Card>
        {user ? (
          <>
            <p>Welcome, {user.username}</p>

            {/* Custom file input with label */}
            <label
              style={{
                display: 'block',
                marginTop: '1rem',
                marginBottom: '0.5rem',
                fontWeight: 'bold',
              }}
            >
              Upload an image of SL2 sorter shoe for AI analysis to detect crack/defect:
            </label>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageUpload}
            />

            {/* Show selected file name */}
            {selectedFile && (
              <p style={{ marginTop: '0.5rem' }}>Selected: {selectedFile.name}</p>
            )}

            {/* Sign out button moved below */}
            <Button
              onClick={() => signOut()}
              style={{ marginTop: '1rem' }}
            >
              Sign Out
            </Button>
          </>
        ) : (
          <Button
            onClick={() => signInWithRedirect({ 
              provider: { custom: 'FederateOIDC' }
            })}
          >
            Login
          </Button>
        )}
      </Card>
    </View>
  );
}

export default App;
